import React from 'react';
import { motion } from 'framer-motion';
import { EventType, EVENT_TYPE_CONFIGS, EventTypeConfig } from '../../types/eventTypes';

interface EventTypeSelectorProps {
    selected: EventType;
    onSelect: (type: EventType) => void;
    className?: string;
}

interface EventTypeButtonProps {
    config: EventTypeConfig;
    selected: boolean;
    onClick: () => void;
}

const EventTypeButton: React.FC<EventTypeButtonProps> = ({
    config,
    selected,
    onClick,
}) => {
    return (
        <motion.button
            type="button"
            onClick={onClick}
            whileTap={{ scale: 0.95 }}
            className={`
        relative p-3 rounded-xl border-2 transition-all
        flex flex-col items-center gap-1.5
        min-h-[80px] min-w-[80px]
        ${selected
                    ? `border-white/50 ${config.bgColor} bg-opacity-20`
                    : 'border-white/20 bg-white/5 hover:border-white/30 hover:bg-white/10'
                }
      `}
        >
            {/* Icon */}
            <span className="text-2xl">{config.icon}</span>

            {/* Label */}
            <span className={`
        text-xs font-medium text-center leading-tight
        ${selected ? 'text-white' : 'text-white/70'}
      `}>
                {config.label}
            </span>

            {/* Selected indicator */}
            {selected && (
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    className="absolute top-1 right-1"
                >
                    <div className="w-4 h-4 rounded-full bg-green-500 flex items-center justify-center">
                        <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                </motion.div>
            )}
        </motion.button>
    );
};

const EventTypeSelector: React.FC<EventTypeSelectorProps> = ({
    selected,
    onSelect,
    className = '',
}) => {
    const eventTypes = Object.values(EVENT_TYPE_CONFIGS);

    return (
        <div className={`space-y-3 ${className}`}>
            <label className="block text-sm font-medium text-white/70">
                Loại sự kiện
            </label>

            <div className="grid grid-cols-4 gap-2">
                {eventTypes.map((config) => (
                    <EventTypeButton
                        key={config.id}
                        config={config}
                        selected={selected === config.id}
                        onClick={() => onSelect(config.id)}
                    />
                ))}
            </div>

            {/* Show description of selected type */}
            <p className="text-xs text-white/50">
                {EVENT_TYPE_CONFIGS[selected].description}
            </p>
        </div>
    );
};

export default EventTypeSelector;
